export const parseOffsetFromString = (timezone) => {
  let offset = 0;

  if (timezone) {
    offset = parseInt(timezone.replace(new RegExp('0', 'g'), ''));
  }

  return offset;
}